import { IMonthsConstant } from "../interfaces/course-planning";

export const monthsConstant: IMonthsConstant[] = [
  { number: 1, label: "Enero", value: "January" },
  { number: 2, label: "Febrero", value: "February" },
  { number: 3, label: "Marzo", value: "March" },
  { number: 4, label: "Abril", value: "April" },
  { number: 5, label: "Mayo", value: "May" },
  { number: 6, label: "Junio", value: "June" },
  { number: 7, label: "Julio", value: "July" },
  { number: 8, label: "Agosto", value: "August" },
  { number: 9, label: "Septiembre", value: "September" },
  { number: 10, label: "Octubre", value: "October" },
  { number: 11, label: "Noviembre", value: "November" },
  { number: 12, label: "Diciembre", value: "December" },
];
